export default function StatsSection() {
  const stats = [
    { icon: 'ri-video-line', value: '120万+', label: '视频资源' },
    { icon: 'ri-user-smile-line', value: '380万+', label: '日活用户' },
    { icon: 'ri-award-line', value: '98%', label: '用户满意度' },
    { icon: 'ri-thumb-up-line', value: '9.1', label: '平均评分' },
    { icon: 'ri-team-line', value: '5万+', label: '内容创作者' },
    { icon: 'ri-eye-line', value: '2.5亿+', label: '月播放量' },
  ];

  return (
    <section
      className="relative w-full px-4 md:px-6 py-14 md:py-20"
      style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20coral%20and%20amber%20tones%2C%20smooth%20flowing%20curves%2C%20minimalist%20geometric%20shapes%2C%20elegant%20and%20modern%20design%2C%20subtle%20texture%2C%20professional%20backdrop%20for%20statistics%20display&width=1800&height=600&seq=stats-bg-01&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-primary-500/90"></div>
      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3 font-heading">
          就要草视频 用数据说话
        </h2>
        <p className="text-sm md:text-base text-background-200/80 mb-10 max-w-xl mx-auto">
          每一组数字背后，都是用户对我们的信任与支持
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50/15 backdrop-blur-sm rounded-lg p-5 border border-background-50/10"
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 bg-background-50/20 rounded-full">
                <i className={`${stat.icon} text-background-50 text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-200/70 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}